<template>
  <div class="row">
    <div class="col_12">
      <div class="card border_none">
        <div class="card_body pl_5 pr_5">
          <div>
            <p>Action: {{ capitalizedStr(record.action) }}</p>
            <template v-if="record.action === 'created' && record.details">
              <p v-for="(value, key) in record.details" :key="key">
                <template v-if="key === 'request_from'">
                  {{ formatString(key) }} - {{ value }}
                </template>
              </p>
            </template>
            <template v-else>
              <p v-for="(value, key) in record.details" :key="key">
                {{ formatString(key) }} - {{ value }}
              </p>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

    export default {
      name: 'CustomerAuditLogHistory',
      props: ['closeModal', 'record'],
      methods: {
        capitalizedStr(str) {
          return str.charAt(0).toUpperCase() + str.slice(1);
        },
        formatString(value) {
          let formattedString = value.replace(/_/g, ' ');
          formattedString = formattedString.charAt(0).toUpperCase() + formattedString.slice(1);
          return formattedString;
        }
      }
    }
</script>
<style scoped>

</style>
